export default "__VITE_ASSET__ChsmUKtB__"